import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import Home from "@/pages/Home";
import Yonetim from "@/pages/Yonetim";
import CategoryPage from "@/pages/CategoryPage";
import KontrplakPage from "@/pages/KontrplakPage";
import Sertifikalar from "@/pages/Sertifikalar";
import Tesekkurler from "@/pages/Tesekkurler";

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <div className="grain min-h-screen bg-white text-[#1A1715]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kaplama-yapay" element={<CategoryPage />} />
            <Route path="/kaplama-yapay/normal" element={<CategoryPage />} />
            <Route path="/kaplama-yapay/3d" element={<CategoryPage />} />
            <Route path="/kaplama" element={<CategoryPage />} />
            <Route path="/kaplama/kok" element={<CategoryPage />} />
            <Route path="/kaplama/kaburga" element={<CategoryPage />} />
            <Route path="/kaplama/piramit" element={<CategoryPage />} />
            <Route path="/kaplama/papel" element={<CategoryPage />} />
            <Route path="/linea" element={<CategoryPage />} />
            <Route path="/vinterio" element={<CategoryPage />} />
            <Route path="/kereste" element={<CategoryPage />} />
            <Route path="/boyali-kaplama" element={<CategoryPage />} />
            <Route path="/kontrplak" element={<KontrplakPage />} />
            <Route path="/sertifikalar" element={<Sertifikalar />} />
            <Route path="/tesekkurler" element={<Tesekkurler />} />
            <Route path="/yonetim" element={<Yonetim />} />
          </Routes>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#1A1715",
                border: "1px solid rgba(242,239,235,0.1)",
                color: "#F2EFEB",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </div>
      </ReactLenis>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
